import * as React from 'react';
import { Image } from '@cian/ui-kit';
import cn from 'clsx';

import img from '../../assets/star24.svg';
import { SuperAgentTooltip } from '../SuperAgentTooltip';

import * as styles from './styles.css';

export interface ISuperAgentStarProps {
  size?: number | string | undefined;
  underlay?: boolean;
}

export const SuperAgentStar: React.FC<React.PropsWithChildren<ISuperAgentStarProps>> = ({ size = 16, underlay }) => (
  <SuperAgentTooltip isOnlyDesktop>
    <div className={cn(styles['star'], underlay && styles['underlay'])}>
      <Image width={size} height={size} src={img} />
    </div>
  </SuperAgentTooltip>
);

SuperAgentStar.displayName = 'SuperAgentStar';
